import { NgRedux } from "@angular-redux/store";
import { Injectable } from "@angular/core";

export interface GlobalMessageAction {
    type: string;
    status: string;
    response: string;
}

@Injectable()
export class GlobalMessageActions {

    static SHOW_MESSAGE = "SHOW_MESSAGE";
    static HIDE_MESSAGE = "HIDE_MESSAGE";

    constructor(private ngRedux: NgRedux<Object>) {
    }

    showGlobalMessage(status, response): void {
        this.ngRedux.dispatch({
            type: GlobalMessageActions.SHOW_MESSAGE,
            status,
            response,
        });
    }

    hideGlobalMessage(): void {
        this.ngRedux.dispatch({type: GlobalMessageActions.HIDE_MESSAGE});
    }
}
